import { render } from "./FlashCards.vue?vue&type=template&id=7cbc45b9&scoped=true"
import script from "./FlashCards.vue?vue&type=script&lang=js"
export * from "./FlashCards.vue?vue&type=script&lang=js"

import "./FlashCards.vue?vue&type=style&index=0&id=7cbc45b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbc45b9"]])

export default __exports__